import { createFileRoute } from '@tanstack/react-router'
import { LibraryPage } from '@/components/library/library-page'
import { useTitle } from '@/lib/use-title'

export const Route = createFileRoute('/_app/library')({ component: LibraryRoute })

function LibraryRoute() {
  useTitle('Library')
  const { me } = Route.useRouteContext()
  return <LibraryPage me={me} />
}
